Px.CMS.PhotoPrintsComponent = class PhotoPrintsComponent extends Px.Component {

  template() {
    switch (this.state.screen) {
    case 'project-loading':
      return this.project_loading_template();
    case 'photo-selection':
      return this.photo_selection_template();
    case 'crop-options':
      return this.crop_options_template();
    default:
      throw new Error(`Unrecognized screen: ${this.state.screen}`);
    }
  }

  project_loading_template() {
    return Px.template`
      <div class="px-photo-prints px-${this.state.mobile_mode ? 'mobile' : 'desktop'}-mode">
        <div class="px-main-area">
          <span class="px-prints-spinner px-project-loading"></span>
        </div>
      </div>
    `;
  }

  photo_selection_template() {
    return Px.template`
      <div class="px-photo-prints px-${this.state.mobile_mode ? 'mobile' : 'desktop'}-mode"
           data-photo-count="${this.uploadedImages.length}"
           data-thumb-size="${this.state.thumbnail_size_photo_selection}">
        <div class="px-main-area">
          <div class="px-top-bar">
            <div class="px-left-item">
              <button class="${this.uploadButtonClasses}" data-onclick="triggerUploadDialog">
                ${Px.raw(PhotoPrintsComponent.icons.add_photos)}
                ${this.uploadButtonLabel}
              </button>
            </div>
            ${Px.if(this.uploadedImages.length > 0, () => {
              return Px.template`
                <div class="px-center-item">
                  <span class="px-photos-total">
                    ${this.getText('photo-count', this.uploadedImages.length).replace('{{count}}', this.uploadedImages.length)}
                  </span>
                  <span class="px-separator"></span>
                  <span class="px-photos-selected">
                    ${this.getText('photos-selected-count', this.state.selected_images.length).replace('{{count}}', this.state.selected_images.length)}
                  </span>
                </div>
                <div class="px-right-item">
                  ${Px.if(this.state.mobile_mode, () => {
                    return Px.template`
                      ${Px.if(this.state.screen === 'crop-options', () => {
                        return Px.template`
                          <button class="px-btn px-btn-primary px-btn-cart"
                                  data-onclick="addToCart"
                                  ${this.addToCartButtonEnabled ? '' : 'disabled'}>
                            ${Px.raw(PhotoPrintsComponent.icons.cart)}
                            ${this.getText(this.data.cart_mode ? 'save-to-cart' : 'add-to-cart')}
                          </button>
                        `;
                      }).elseIf(this.state.screen === 'photo-selection', () => {
                        return Px.template`
                          <button class="px-btn px-btn-primary px-btn-cart"
                                  data-onclick="goToCropOptions"
                                  ${this.goToCropOptionsButtonEnabled ? '' : 'disabled'}>
                            ${this.croppingAndOptionsButtonLabel}
                            ${Px.raw(PhotoPrintsComponent.icons.next)}
                          </button>
                        `;
                      })}
                    `;
                  }).else(() => {
                    return Px.template`
                      <button class="${this.autoselectAllButtonClass}" data-onclick="toggleAutoselect">
                        ${Px.raw(this.autoselectAllButtonIcon)}
                        ${this.autoselectAllButtonLabel}
                      </button>
                      <div class="px-thumb-size-selector">
                        <button class="px-thumb-size" data-size="single" data-onclick="setPhotoSelectionThumbSize">
                          ${Px.raw(PhotoPrintsComponent.icons.thumbnails_single)}
                        </button>
                        <button class="px-thumb-size" data-size="large" data-onclick="setPhotoSelectionThumbSize">
                          ${Px.raw(PhotoPrintsComponent.icons.thumbnails_large)}
                        </button>
                        <button class="px-thumb-size" data-size="small" data-onclick="setPhotoSelectionThumbSize">
                          ${Px.raw(PhotoPrintsComponent.icons.thumbnails_small)}
                        </button>
                      </div>
                    `;
                  })}
                </div>
              `;
            })}

            ${Px.if(this.data.header_instructions_photo_selection, () => {
              return Px.template`
                <div class="px-header-instructions">
                  <div class="px-header-instructions-content">
                    ${Px.raw(this.data.header_instructions_photo_selection)}
                  </div>
                </div>
              `;
            })}
          </div>

          <div class="px-prints">
            ${this.uploadedImages.map(image => {
              return Px.template`
                <div class="px-print"
                     data-guid="${image.guid}"
                     data-selected="${this.state.selected_images.includes(image.guid)}">
                  <figure class="px-img-wrapper">
                    <img src="${this.getThumbnailUrlForSize(image, this.thumbnailPixelSizePhotoSelection)}"
                         style="aspect-ratio:${image.width}/${image.height}"
                         draggable="false"
                         data-onclick="toggleImageSelection"
                         data-ontouchstart="focusImageOnLongPress"
                         data-oncontextmenu="preventDefault"
                    />
                    ${Px.if(this.imageTotalQuantity(image.guid), () => {
                      return Px.template`
                        <div class="px-quantity-bubble">
                          <span>${this.imageTotalQuantity(image.guid)}</span>
                          <div class="px-quantity-expand">
                            ${this.printProducts.map((print_product, idx) => {
                              const qty = this.imageQuantityForSize(image.guid, idx);
                              if (qty === 0) {
                                return '';
                              }
                              return Px.template`
                                <span class="px-quantity-info">
                                  <span>${print_product.label} &times; ${qty}</span>
                                </span>
                              `;
                            })}
                          </div>
                        </div>
                      `;
                    })}
                    <button class="px-icon px-delete"
                            data-onclick="removeImage"
                            title="${this.getText('delete-image')}">
                      ${Px.raw(PhotoPrintsComponent.icons.trash)}
                    </button>
                  </figure>
                  <div class="px-filename" ${this.data.show_image_filenames ? '' : 'hidden'}>
                    ${image.filename}
                  </div>
                </div>
              `;
            })}
          </div>

          ${Px.if(this.state.mobile_mode, () => {
            return Px.template`
              <div class="px-bottom-bar" data-open="${this.state.bottom_bar_open}">
                <button class="px-select-all-btn ${this.autoselectAllButtonClass}"
                        data-onclick="toggleAutoselect">
                  ${Px.raw(this.autoselectAllButtonIcon)}
                  ${this.autoselectAllButtonLabel}
                </button>
                <div class="px-bottom-bar-top" data-onclick="toggleBottomBar">
                  <div>
                    <div class="px-bottom-bar-handle">
                      ${Px.raw(PhotoPrintsComponent.icons.bottom_bar_handle)}
                      ${this.getText('select-sizes')}
                    </div>
                  </div>
                  <div>
                    ${Px.if(this.state.total_price, () => {
                      return Px.template`
                        <div class="px-total-price">
                          ${Px.Util.formatCurrency(this.state.total_price || 0, this.data.currency_formatting_settings)}
                        </div>
                      `;
                    })}
                  </div>
                </div>
                <div class="px-bottom-bar-content">
                  ${Px.if(this.state.selected_images.length > 0, () => {
                    return Px.template`
                      <div class="px-print-sizes">
                        ${this.printProductsByCategory.map(category => {
                          return Px.template`
                            ${Px.if(category.label || this.printProductsByCategory.length > 1, () => {
                              return Px.template`
                                <div class="px-category">
                                  ${category.label}
                                </div>
                              `;
                            })}
                            ${category.print_products.map(product => {
                              const idx = product.idx;
                              const current_qty = this.currentSelectionDisplayQuantityForSize(idx);
                              return Px.template`
                                <div class="px-print-size"
                                    data-idx="${idx}"
                                    data-selected="${current_qty === '*' || current_qty > 0}">
                                  <div class="px-label">
                                    ${product.label}
                                  </div>
                                  <div class="px-quantity">
                                    <button data-onclick="massDecreaseQuantity" ${current_qty === 0 ? 'disabled' : ''}>
                                      ${Px.raw(PhotoPrintsComponent.icons.minus)}
                                    </button>
                                    <span>
                                      ${current_qty}
                                    </span>
                                    <button data-onclick="massIncreaseQuantity">
                                      ${Px.raw(PhotoPrintsComponent.icons.plus)}
                                    </button>
                                  </div>
                                  <div class="px-price">
                                    ${Px.Util.formatCurrency(this.unitPrice(idx), this.data.currency_formatting_settings)}
                                  </div>
                                </div>
                              `;
                            })}
                          `;
                        })}
                      </div>
                    `;
                  }).else(() => {
                    return Px.template`
                      <p class="px-bottom-bar-notice">
                        ${this.getText('no-images-selected')}
                      </p>
                    `;
                  })}
                </div>
                <div class="px-bottom-bar-backdrop" data-onclick="toggleBottomBar">
                </div>
              </div>
              ${Px.if(this.focusedImage, () => {
                const image = this.focusedImage;
                return Px.template`
                  <div class="px-focused-image" data-guid="${image.guid}" data-onclick="unfocusImage">
                    <figure>
                      <img src="${this.getThumbnailUrlForSize(image, 600)}"
                           style="aspect-ratio:${image.width}/${image.height}"
                           draggable="false"
                      />
                    </figure>
                    ${Px.if(this.imageTotalQuantity(image.guid), () => {
                      return Px.template`
                        <div class="px-quantity-panel">
                          <table>
                            ${this.printProducts.map((print_product, idx) => {
                              const qty = this.imageQuantityForSize(image.guid, idx);
                              if (qty === 0) {
                                return '';
                              }
                              return Px.template`
                                <tr class="px-quantity-info">
                                  <td class="px-qty">${qty}</td>
                                  <td class="px-size-label">${print_product.label}</td>
                                </tr>
                              `;
                            })}
                          </table>
                        </div>
                      `;
                    })}
                    <div class="px-delete-btn-wrapper">
                      <button class="px-btn px-btn-danger"
                              data-onclick="removeImage"
                              title="${this.getText('delete-image')}">
                        ${Px.raw(PhotoPrintsComponent.icons.trash)}
                        ${this.getText('delete-image')}
                      </button>
                    </div>
                  </div>
                `;
              })}
            `;
          })}
        </div>

        <div class="px-sidebar">
          <div class="px-sidebar-content">
            <div class="px-sidebar-top">
              <div class="px-total-price">
                ${Px.Util.formatCurrency(this.state.total_price || 0, this.data.currency_formatting_settings)}
              </div>
              <button class="px-btn px-btn-primary px-btn-cart"
                      data-onclick="goToCropOptions"
                      ${this.goToCropOptionsButtonEnabled ? '' : 'disabled'}>
                ${this.getText('cropping-and-options')}
                ${Px.raw(PhotoPrintsComponent.icons.next)}
              </button>
            </div>
            <div class="px-scroll">
              <p class="px-sidebar-instructions">
                <span class="px-heading">
                  ${this.getText('print-sizes')}
                 </span>
                ${this.getText('print-size-selection-instructions')}
              </p>
              ${Px.if(this.state.selected_images.length > 0, () => {
                return Px.template`
                  <div class="px-print-sizes">
                    ${this.printProductsByCategory.map(category => {
                      return Px.template`
                        ${Px.if(category.label || this.printProductsByCategory.length > 1, () => {
                          return Px.template`
                            <div class="px-category">
                              ${category.label}
                            </div>
                          `;
                        })}
                        ${category.print_products.map(product => {
                          const idx = product.idx;
                          const current_qty = this.currentSelectionDisplayQuantityForSize(idx);
                          return Px.template`
                            <div class="px-print-size"
                                data-idx="${idx}"
                                data-selected="${current_qty === '*' || current_qty > 0}">
                              <div class="px-label">
                                ${product.label}
                                ${Px.if(product.description, () => {
                                  return Px.template`
                                    <span class="px-info-bubble"
                                          data-onmouseenter="showDescriptionPopover"
                                          data-onmouseleave="hideDescriptionPopover">
                                      ${Px.raw(PhotoPrintsComponent.icons.info_circle)}
                                    </span>
                                    <div class="px-info-popover" popover="hint">
                                      ${Px.raw(product.description)}
                                    </div>
                                  `;
                                })}
                              </div>
                              <div class="px-quantity">
                                <button data-onclick="massDecreaseQuantity" ${current_qty === 0 ? 'disabled' : ''}>
                                  ${Px.raw(PhotoPrintsComponent.icons.minus)}
                                </button>
                                <span data-onclick="massPromptQuantity">
                                  ${current_qty}
                                </span>
                                <button data-onclick="massIncreaseQuantity">
                                  ${Px.raw(PhotoPrintsComponent.icons.plus)}
                                </button>
                              </div>
                              <div class="px-price">
                                ${Px.Util.formatCurrency(this.unitPrice(idx), this.data.currency_formatting_settings)}
                              </div>
                            </div>
                          `;
                        })}
                      `;
                    })}
                  </div>
                `;
              })}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  crop_options_template() {
    const r = this.renderChild;
    return Px.template`
      <div class="px-photo-prints px-${this.state.mobile_mode ? 'mobile' : 'desktop'}-mode"
           data-photo-count="${this.uploadedImages.length}"
           data-thumb-size="${this.state.thumbnail_size_crop_options}">
        <div class="px-main-area">
          <div class="px-top-bar">
            <div class="px-left-item">
              <button class="px-btn px-btn-secondary" data-onclick="goToPhotoSelection">
                ${Px.raw(PhotoPrintsComponent.icons.back.replace('width="18"', 'width="14"'))}
                ${this.getText('back')}
              </button>
            </div>
            <div class="px-center-item">
              <span class="px-photos-total">
                ${this.getText('photo-count', this.uploadedImages.length).replace('{{count}}', this.uploadedImages.length)}
              </span>
              <span class="px-separator"></span>
              <span class="px-photos-selected">
                ${this.getText('total-prints-count', this.totalPrintsQuantity).replace('{{count}}', this.totalPrintsQuantity)}
              </span>
            </div>
            <div class="px-right-item">
              ${Px.if(this.state.mobile_mode, () => {
                return Px.template`
                  <button class="px-btn px-btn-primary px-btn-cart"
                          data-onclick="addToCart"
                          ${this.addToCartButtonEnabled ? '' : 'disabled'}>
                    ${Px.raw(PhotoPrintsComponent.icons.cart)}
                    ${this.getText(this.data.cart_mode ? 'save-to-cart' : 'add-to-cart')}
                  </button>
                `;
              }).else(() => {
                return Px.template`
                  <div class="px-thumb-size-selector">
                    <button class="px-thumb-size" data-size="single" data-onclick="setCropOptionsThumbSize">
                      ${Px.raw(PhotoPrintsComponent.icons.thumbnails_single)}
                    </button>
                    <button class="px-thumb-size" data-size="large" data-onclick="setCropOptionsThumbSize">
                      ${Px.raw(PhotoPrintsComponent.icons.thumbnails_large)}
                    </button>
                    <button class="px-thumb-size" data-size="small" data-onclick="setCropOptionsThumbSize">
                      ${Px.raw(PhotoPrintsComponent.icons.thumbnails_small)}
                    </button>
                  </div>
                `;
              })}
            </div>

            ${Px.if(this.data.header_instructions_crop_options, () => {
              return Px.template`
                <div class="px-header-instructions">
                  <div class="px-header-instructions-content">
                    ${Px.raw(this.data.header_instructions_crop_options)}
                  </div>
                </div>
              `;
            })}
          </div>

          <div class="px-prints-overview">
            ${this.printProducts.map((product, idx) => {
              if (this.sizeTotalQuantity(idx) > 0) {
                return Px.template`
                  <div class="px-print-orderline" data-size-idx="${idx}">
                    <div class="px-heading">
                      ${product.label}
                    </div>
                    <div class="px-prints">
                      ${this.uploadedImages.map(image => {
                        const quantity = this.imageQuantityForSize(image.guid, idx);
                        if (quantity > 0) {
                          return Px.template`
                            <div class="px-print"
                                 data-guid="${image.guid}"
                                 data-shrink-to-fit-mode="${this.isImageFitToShrink(image.guid, idx)}">
                              <figure class="px-img-wrapper"
                                      ${Px.if(this.state.mobile_mode, () => {
                                        return Px.template`data-onclick="openCropTool"`;
                                      })}
                                      data-oncontextmenu="preventDefault">
                                <img src="${this.getThumbnailUrlForSize(image, this.thumbnailPixelSizeCropOptions)}"
                                     style="visibility:hidden; aspect-ratio:${image.width}/${image.height};" />
                                ${r(Px.CMS.ImageAdjustToolComponent,
                                    this.imageAdjustToolComponentKey(image.guid, idx, 'inline'),
                                    this.imageAdjustToolComponentProps(image, idx, true))}
                                <div class="px-quantity-bubble">
                                  ${Px.if(quantity > 1, () => {
                                    return Px.template`
                                      <div class="px-quantity-expand px-quantity-decrease">
                                        <button data-onclick="decreaseQuantity">
                                          ${Px.raw(PhotoPrintsComponent.icons.minus)}
                                        </button>
                                      </div>
                                    `;
                                  })}
                                  <div class="px-quantity-expand px-quantity-increase">
                                    <button data-onclick="increaseQuantity">
                                      ${Px.raw(PhotoPrintsComponent.icons.plus)}
                                    </button>
                                  </div>
                                  <span>${quantity}</span>
                                </div>
                                <button class="px-icon px-shrink-to-fit"
                                        data-onclick="toggleShrinkToFit"
                                        title="${this.getText('shrink-to-fit-button-title')}">
                                  ${Px.raw(PhotoPrintsComponent.icons.shrink_to_fit)}
                                </button>
                                <button class="px-icon px-crop"
                                        data-onclick="openCropTool"
                                        title="${this.getText('crop-button-title')}">
                                  ${Px.raw(PhotoPrintsComponent.icons.crop)}
                                </button>
                                <button class="px-icon px-delete"
                                        data-onclick="removePrint"
                                        title="${this.getText('delete-print')}">
                                  ${Px.raw(PhotoPrintsComponent.icons.trash)}
                                </button>
                              </figure>
                            </div>
                          `;
                        }
                      })}
                    </div>
                  </div>
                `;
              }
            })}
          </div>

          ${Px.if(this.state.mobile_mode, () => {
            return Px.template`
              <div class="px-bottom-bar" data-open="${this.state.bottom_bar_open}">
                <div class="px-bottom-bar-top" data-onclick="toggleBottomBar">
                  <div>
                    ${Px.if(this.printProducts.some((product, idx) => this.hasOptionsForSize(idx)), () => {
                      return Px.template`
                        <div class="px-bottom-bar-handle">
                          ${Px.raw(PhotoPrintsComponent.icons.bottom_bar_handle)}
                          ${this.getText('select-options')}
                        </div>
                      `;
                    })}
                  </div>
                  <div>
                    ${Px.if(this.state.total_price, () => {
                      return Px.template`
                        <div class="px-total-price">
                          ${Px.Util.formatCurrency(this.state.total_price || 0, this.data.currency_formatting_settings)}
                        </div>
                      `;
                    })}
                  </div>
                </div>
                <div class="px-bottom-bar-content">
                  ${this.printProducts.map((product, idx) => {
                    if (this.hasOptionsForSize(idx)) {
                      return Px.template`
                        <div class="px-size-options">
                          <div class="px-heading">
                            ${product.label}
                          </div>
                          <div class="px-options">
                            ${this.optionsForDisplay(idx).map(([type, option]) => {
                              return Px.template`
                                <div class="px-option">
                                  <div class="px-label">${option.name}</div>
                                  ${this.option_control_template(type, idx, option)}
                                </div>
                              `;
                            })}
                          </div>
                        </div>
                      `;
                    }
                  })}
                </div>
                <div class="px-bottom-bar-backdrop" data-onclick="toggleBottomBar">
                </div>
              </div>
            `;
          })}
        </div>

        <div class="px-sidebar">
          <div class="px-sidebar-content">
            <div class="px-sidebar-top">
              <div class="px-total-price">
                ${Px.Util.formatCurrency(this.state.total_price, this.data.currency_formatting_settings)}
              </div>
              <button class="px-btn px-btn-primary px-btn-cart"
                      data-onclick="addToCart"
                      ${this.addToCartButtonEnabled ? '' : 'disabled'}>
                ${Px.raw(PhotoPrintsComponent.icons.cart)}
                ${this.getText(this.data.cart_mode ? 'save-to-cart' : 'add-to-cart')}
              </button>
            </div>
            <div class="px-scroll">
              ${Px.if(this.printProducts.some((product, idx) => this.hasOptionsForSize(idx)), () => {
                return Px.template`
                  <p class="px-sidebar-instructions">
                    <span class="px-heading">
                      ${this.getText('product-options')}
                    </span>
                    ${this.getText('option-selection-instructions')}
                  </p>
                `;
              })}

              ${this.printProducts.map((product, idx) => {
                if (this.hasOptionsForSize(idx)) {
                  return Px.template`
                    <div class="px-size-options">
                      <div class="px-heading">
                        ${product.label}
                      </div>
                      <div class="px-options">
                        ${this.optionsForDisplay(idx).map(([type, option]) => {
                          return Px.template`
                            <div class="px-option">
                              <div class="px-label">${option.name}</div>
                              ${this.option_control_template(type, idx, option)}
                            </div>
                          `;
                        })}
                      </div>
                    </div>
                  `;
                }
              })}
            </div>
          </div>
        </div>

        ${Px.if(this.isCroppingActive, () => {
          const size_idx = this.state.crop_size_idx;
          const image = this.uploadedImages.find(image => image.guid === this.state.crop_image_guid);
          return Px.template`
            <div class="px-cropping-overlay"
                 data-guid="${image.guid}"
                 data-size-idx="${size_idx}"
                 data-onclick="closeCroppingTool">
              ${r(Px.CMS.ImageAdjustToolComponent,
                  this.imageAdjustToolComponentKey(image.guid, size_idx),
                  this.imageAdjustToolComponentProps(image, size_idx))}
            </div>
          `;
        })}

        ${Px.if(this.state.is_adding_to_cart, () => {
          return Px.template`
            <div class="px-please-wait-overlay">
              <span>
                ${this.getText('please-wait')}
              </span>
              <span class="px-prints-spinner"></span>
              <span>
                ${Px.if(this.state.add_to_cart_total_projects > 0, () => {
                  return Px.template`
                    ${this.addToCartPercent}%
                  `;
                })}
              </span>
            </div>
          `;
        })}
      </div>
    `;
  }

  option_control_template(type, size_idx, option) {
    switch (option.control_type) {
    case 'radio_buttons':
      return this.option_control_radio_button_template(type, size_idx, option);
    case 'image_buttons':
      return this.option_control_image_button_template(type, size_idx, option);
    default:
      return this.option_control_dropdown_template(type, size_idx, option);
    }
  }

  option_control_dropdown_template(type, size_idx, option) {
    const selected_value = this.optionValueForSize(type, size_idx, option);

    let values = mobx.toJS(option.values);
    if (!option.is_required) {
      values = [{name: '', code: ''}].concat(values);
    }

    return Px.template`
      <select data-code="${option.code}"
              data-type="${type}"
              data-size-idx="${size_idx}"
              data-onchange="storeOptionValueFromSelect">
        ${values.map(value => {
          const selected = selected_value === value.code ? 'selected' : '';
          let price = '';
          if (value.price > 0) {
            const formatted_price = Px.Util.formatCurrency(value.price , this.data.currency_formatting_settings);
            price = `+${formatted_price}`;
          }
          return Px.template`
            <option value="${value.code}" ${selected}>
              ${value.name} ${price}
            </option>
          `;
        })}
      </select>
    `;
  }

  option_control_radio_button_template(type, size_idx, option) {
    const selected_value = this.optionValueForSize(type, size_idx, option);

    return Px.template`
      <div class="px-radio-control"
           data-type="${type}"
           data-size-idx="${size_idx}">
        ${option.values.map(value => {
          const checked = selected_value === value.code ? 'checked' : '';
          let price = '';
          if (value.price > 0) {
            const formatted_price = Px.Util.formatCurrency(value.price , this.data.currency_formatting_settings);
            price = `(+${formatted_price})`;
          }
          return Px.template`
            <label>
              <input type="radio"
                value="${value.code}"
                data-code="${option.code}"
                data-onchange="storeOptionValueFromRadioButton"
                ${checked}
              />
              <span class="px-icon">
                ${Px.raw(PhotoPrintsComponent.icons.checkbox)}
              </span>
              <span class="px-radio-label">
                ${value.name} ${price}
              </span>
            </label>
          `;
        })}
      </div>
    `;
  }

  option_control_image_button_template(type, size_idx, option) {
    const selected_value = this.optionValueForSize(type, size_idx, option);

    return Px.template`
      <div class="px-image-control"
           data-type="${type}"
           data-size-idx="${size_idx}">
        ${option.values.map(value => {
          const checked = selected_value === value.code ? 'checked' : '';
          let price = '';
          if (value.price > 0) {
            const formatted_price = Px.Util.formatCurrency(value.price , this.data.currency_formatting_settings);
            price = `+${formatted_price}`;
          }
          return Px.template`
            <label>
              <input type="radio"
                value="${value.code}"
                data-code="${option.code}"
                data-onchange="storeOptionValueFromRadioButton"
                ${checked}
              />
              <img src="${value.image_url}" />
              ${Px.if(price, () => {
                return Px.template`
                  <span class="px-option-price">
                    ${price}
                  </span>
                `;
              })}
              <span class="px-radio-label">
                ${value.name}
              </span>
            </label>
          `;
        })}
      </div>
    `;
  }

  get dataProperties() {
    return {
      project_id: {std: null},
      // The products can be given either as `design_products` or as `design_product_categories`.
      // `design_products` takes precedence.
      design_products: {std: []},
      design_product_categories: {std: []},
      image_sources: {std: 'local qr'},
      dropbox_app_key: {std: null},
      google_client_id: {std: null},
      cart_mode: {std: false},
      cart_page: {std: '/site/cart'},
      autoselect_images: {std: true},
      header_instructions_photo_selection: {std: ''},
      header_instructions_crop_options: {std: ''},
      default_thumbnail_size: {std: 'large'},
      default_thumbnail_size_photo_selection: {std: null},
      default_thumbnail_size_crop_options: {std: null},
      show_image_filenames: {std: false},
      autorotate_images: {std: true},
      currency_formatting_settings: {std: {}},
      language: {std: 'en'},
      texts: {std: {}},
      session_key: {std: null},
      integration: {std: null}
    };
  }

  static get properties() {
    return {
      mobile_mode: {type: 'bool', std: false},
      screen: {type: 'str', std: 'photo-selection'},
      uploads: {type: 'map', std: mobx.observable.map()},
      autoselect_all: {type: 'bool', std: true},
      selected_images: {type: 'array', std: mobx.observable.array()},
      last_selected_range: {type: 'obj', std: null},
      size_selections: {type: 'map', std: mobx.observable.map()},
      reset_selection_process: {type: 'bool', std: false},
      image_values: {type: 'map', std: mobx.observable.map()},
      variant_selections: {type: 'map', std: mobx.observable.map()},
      template_option_selections: {type: 'map', std: mobx.observable.map()},
      focused_image_guid: {type: 'str', std: null},
      crop_image_guid: {type: 'str', std: null},
      crop_size_idx: {type: 'int', std: 0},
      total_price: {type: 'float', std: null},
      pricing_data: {type: 'array', std: mobx.observable.array()},
      thumbnail_size_photo_selection: {type: 'string', std: 'large'},
      thumbnail_size_crop_options: {type: 'string', std: 'large'},
      bottom_bar_open: {type: 'bool', std: false},
      theme_store: {type: 'map', std: mobx.observable.map()},
      is_transitioning_to_cropping_and_options: {type: 'bool', std: false},
      is_adding_to_cart: {type: 'bool', std: false},
      add_to_cart_total_projects: {type: 'int', std: 0},
      add_to_cart_steps_completed: {type: 'int', std: 0}
    };
  }

  constructor(props) {
    super(props);

    this._fetch_price_abort_controllers = [];
    this._project_data = null;

    this.mobileModeListener = this.mobileModeListener.bind(this);

    this.loadThemes();

    this.state.autoselect_all = this.data.autoselect_images;

    this.state.thumbnail_size_photo_selection =
      this.data.default_thumbnail_size_photo_selection || this.data.default_thumbnail_size;
    this.state.thumbnail_size_crop_options =
      this.data.default_thumbnail_size_crop_options || this.data.default_thumbnail_size;

    this.state.mobile_mode = Px.Util.matchMedia('mobile').matches;

    if (this.data.project_id) {
      this.state.screen = 'project-loading';
      this.loadProject();
    } else {
      this.loadStateFromSession();
    }

    this.registerReaction(() => this.getSessionState(), state => this.saveStateIntoSession(state), {
      name: 'Px.CMS.PhotoPrintsComponent::SaveStateIntoSession',
      equals: mobx.comparer.structural,
      delay: 250
    });

    this.registerReaction(() => this.priceVariables, variables => this.fetchPrices(variables), {
      fireImmediately: true,
      name: 'Px.CMS.PhotoPrintsComponent::FetchPriceReaction',
      equals: mobx.comparer.structural,
      delay: 250
    });

    Px.Util.matchMedia('mobile').addEventListener('change', this.mobileModeListener);

    this.on('mount', () => {
      if (this.uploadedImages.length === 0) {
        // Don't trigger upload dialog if we are editing an existing project since at mount time
        // the project data (and with it the uploadedImages) won't be available yet.
        // We don't expect projects without images anyway.
        if (!this.data.project_id) {
          this.triggerUploadDialog();
        }
      }
    });
  }

  destroy() {
    Px.Util.matchMedia('mobile').removeEventListener('change', this.mobileModeListener);
    super.destroy();
  }

  isSessionItemNestedMap(key) {
    const two_level_maps = [
      'size_selections',
      'image_values',
      'variant_selections',
      'template_option_selections'
    ];

    return two_level_maps.includes(key);
  }

  getSessionState() {
    const session_item_keys = [
      'uploads',
      'autoselect_all',
      'selected_images',
      'size_selections',
      'image_values',
      'variant_selections',
      'template_option_selections'
    ];

    const session_state = {};

    session_item_keys.forEach(key => {
      const value = this.state[key];
      const type = PhotoPrintsComponent.properties[key].type;
      switch (type) {
      case 'bool':
      case 'int':
      case 'float':
      case 'str':
        session_state[key] = value;
        break;
      case 'array':
        session_state[key] = Array.from(value);
        break;
      case 'map':
        session_state[key] = Array.from(value.entries());
        if (this.isSessionItemNestedMap(key)) {
          session_state[key] = session_state[key].map(e => [e[0], Array.from(e[1].entries())]);
        }
        break;
      default:
        throw new Error(`Don't know how to serialize property ${key} of type ${type}`);
      }
    });

    return session_state;
  }

  static sessionStorageKey(session_key) {
    if (!session_key) {
      return null;
    }
    return `photo-prints-session-${session_key}`;
  }

  saveStateIntoSession(session_state) {
    const storage_key = PhotoPrintsComponent.sessionStorageKey(this.data.session_key);
    if (!storage_key) {
      return;
    }

    sessionStorage.setItem(storage_key, JSON.stringify(session_state));
  }

  loadStateFromSession() {
    const storage_key = PhotoPrintsComponent.sessionStorageKey(this.data.session_key);
    if (!storage_key) {
      return;
    }

    let json_data;
    try {
      json_data = sessionStorage.getItem(storage_key);
    } catch (e) {
      console.warn(e);
    }

    if (!json_data) {
      return;
    }

    const data = JSON.parse(json_data);

    mobx.runInAction(() => {
      Object.keys(data).forEach(key => {
        let value = data[key];
        const type = PhotoPrintsComponent.properties[key] && PhotoPrintsComponent.properties[key].type;
        if (!type) {
          console.warn(`Property ${key} not recognized; ignoring`);
          return;
        }
        switch (type) {
        case 'bool':
        case 'int':
        case 'float':
        case 'str':
        case 'array':
          this.state[key] = value;
          break;
        case 'map':
          if (this.isSessionItemNestedMap(key)) {
            value = value.map(e => [e[0], new Map(e[1])]);
          }
          this.state[key] = new Map(value);
          break;
        default:
          console.warn(`Property type ${type} not supported`);
        }
      });
    });
  }

  static removeSession(session_key) {
    const storage_key = this.sessionStorageKey(session_key);
    if (!storage_key) {
      return;
    }

    try {
      sessionStorage.removeItem(storage_key);
    } catch (e) {
      console.warn(e);
    }
  }

  removeStateFromSession() {
    PhotoPrintsComponent.removeSession(this.data.session_key);
  }

  static get computedProperties() {
    return {
      externalIntegration: function() {
        return PhotoPrintsComponent.Integrations[this.data.integration] || {};
      },
      // Takes this.data.design_products, or this.data.design_product_categories where the same product
      // may be repeated for multiple collections, and makes the list unique.
      designProducts: function() {
        if (this.data.design_products.length > 0) {
          return this.data.design_products;
        }
        const design_products = [];
        const products_seen = new Set();
        this.data.design_product_categories.forEach(category => {
          category.design_products.forEach(design_product => {
            const uid = `${design_product.product_id}:${design_product.theme_id}`;
            if (!products_seen.has(uid)) {
              products_seen.add(uid);
              design_products.push(design_product);
            }
          });
        });
        return design_products;
      },
      loaded: function() {
        const theme_store = this.state.theme_store;
        const theme_ids = new Set(this.designProducts.map(dp => dp.theme_id));
        if (theme_store.size !== theme_ids.size) {
          return false;
        }
        return Array.from(this.state.theme_store.values()).every(val => val !== null);
      },
      allUploads: function() {
        const uploads = [];
        for (const [upload_guid, items] of this.state.uploads) {
          const files = mobx.toJS(items);
          files.forEach(file => {
            file.upload_guid = upload_guid;
            uploads.push(file);
          });
        }
        return uploads;
      },
      successfulUploads: function() {
        return this.allUploads.filter(upload => upload.result);
      },
      uploadedImages: function() {
        const images = [];
        this.successfulUploads.forEach(upload => {
          const guid = `${upload.upload_guid}:${upload.result.id}`;
          const image = Object.assign({guid: guid}, upload.result);
          images.push(image);
        });
        return images;
      },
      focusedImage: function() {
        return this.uploadedImages.find(image => image.guid === this.state.focused_image_guid);
      },
      goToCropOptionsButtonEnabled: function() {
        // In mobile mode the button is enabled even if total quantity is zero,
        // because in that case the button opens up the size selection panel.
        if (this.state.mobile_mode) {
          return true;
        }
        if (this.totalPrintsQuantity === 0) {
          return false;
        }
        // TODO: Disable if uploads still in progress.
        return true;
      },
      addToCartButtonEnabled: function() {
        if (this.state.is_transitioning_to_cropping_and_options || this.state.is_adding_to_cart) {
          return false;
        }
        return true;
      },
      uploadButtonLabel: function() {
        if (this.uploadedImages.length > 0) {
          if (this.state.mobile_mode) {
            return this.getText('add-photos-short');
          } else {
            return this.getText('add-photos-long');
          }
        } else {
          return this.getText('select-photos');
        }
      },
      uploadButtonClasses: function() {
        const classes = ['px-btn', 'px-upload-btn'];
        if (this.uploadedImages.length > 0) {
          classes.push('px-btn-secondary');
        } else {
          classes.push('px-btn-primary');
        }
        return classes.join(' ');
      },
      autoselectAllButtonClass: function() {
        const classes = ['px-btn'];
        if (this.state.autoselect_all) {
          classes.push('px-btn-primary');
        } else {
          classes.push('px-btn-secondary');
        }
        return classes.join(' ');
      },
      autoselectAllButtonIcon: function() {
        if (this.state.autoselect_all) {
          return PhotoPrintsComponent.icons.toggle_on;
        } else {
          return PhotoPrintsComponent.icons.toggle_off;
        }
      },
      autoselectAllButtonLabel: function() {
        if (this.state.autoselect_all) {
          return this.getText('deselect-all');
        } else {
          return this.getText('select-all');
        }
      },
      croppingAndOptionsButtonLabel: function() {
        if (this.state.mobile_mode) {
          return this.getText('next');
        } else {
          return this.getText('cropping-and-options');
        }
      },
      printProducts: function() {
        if (!this.loaded) {
          return [];
        }
        const products = [];
        this.designProducts.forEach(design_product => {
          const theme_json = this.state.theme_store.get(design_product.theme_id);
          if (theme_json) {
            products.push({
              product_id: design_product.product_id,
              sku: design_product.sku,
              theme: theme_json,
              label: design_product.label || theme_json.name,
              description: design_product.description,
              collections: design_product.collections,
              variants: design_product.variants || [],
              template_options: design_product.template_options || []
            });
          }
        });
        return products;
      },
      printProductsByCategory: function() {
        if (this.data.design_products.length > 0) {
          return [{
            label: '',
            print_products: this.printProducts.map((product, idx) => Object.assign({idx: idx}, product))
          }];
        }
        const products_by_category = [];
        this.data.design_product_categories.forEach(category => {
          const print_products = [];
          category.design_products.forEach(design_product => {
            const idx = this.printProducts.findIndex(product => {
              return product.product_id === design_product.product_id && product.theme.id === design_product.theme_id;
            });
            if (idx !== -1) {
              print_products.push(Object.assign({idx: idx}, this.printProducts[idx]));
            }
          });
          products_by_category.push({
            label: category.label,
            print_products: print_products
          });
        });
        return products_by_category;
      },
      totalPrintsQuantity: function() {
        let total = 0;
        this.printProducts.forEach((product, idx) => {
          total += this.sizeTotalQuantity(idx);
        });
        return total;
      },
      isCroppingActive: function() {
        return this.state.crop_image_guid !== null;
      },
      thumbnailPixelSizePhotoSelection: function() {
        return this.thumbnailPixelSize(this.state.thumbnail_size_photo_selection);
      },
      thumbnailPixelSizeCropOptions: function() {
        return this.thumbnailPixelSize(this.state.thumbnail_size_crop_options);
      },
      addToCartPercent: function() {
        // When adding to cart there are three async steps that need to be completed for reach print size/project:
        // 1. Create the project.
        // 2. Update the project with pages.
        // 3. Add the project to the cart.
        const step_count = 3;
        const total_steps = this.state.add_to_cart_total_projects * step_count;
        if (total_steps === 0) {
          return 0;
        }
        return Math.round(100 * this.state.add_to_cart_steps_completed / total_steps);
      },
      priceVariables: function() {
        if (!this.loaded) {
          return null;
        }
        return this.printProducts.map((print_product, idx) => {
          return {
            product_id: print_product.product_id,
            theme_id: print_product.theme.id,
            cut_print_quantity: this.sizeTotalQuantity(idx),
            variants: this.variantParameters(idx),
            template_options: this.templateOptionParameters(idx)
          };
        });
      }
    };
  }

  getText(attr_name, count) {
    let text;
    if (typeof count === 'number' && window.Intl && window.Intl.PluralRules) {
      const pluralizer = new Intl.PluralRules(this.data.language);
      const plural_tag = pluralizer.select(count);
      const attr_with_tag = `${attr_name}-${plural_tag}`;
      text = this.data.texts[attr_with_tag] || this.data.texts[attr_name] || PhotoPrintsComponent.DEFAULT_TEXTS[attr_with_tag];
    }
    if (!text) {
      text = this.data.texts[attr_name] || PhotoPrintsComponent.DEFAULT_TEXTS[attr_name];
    }
    return text;
  }

  cropAspectRatioForSize(idx) {
    return this.printProducts[idx].theme.crop_aspect_ratio || 1;
  }

  shouldAutorotate(print_product, image) {
    if (!this.data.autorotate_images) {
      return false;
    }
    const product_aspect_ratio = print_product.theme.crop_aspect_ratio_float;
    const image_aspect_ratio = image.width / image.height;
    if (product_aspect_ratio === 1 || image_aspect_ratio === 1) {
      return false;
    }
    const product_orientation = product_aspect_ratio < 1 ? 'portrait' : 'landscape';
    const image_orientation = image_aspect_ratio < 1 ? 'portrait' : 'landscape';
    return image_orientation !== product_orientation;
  }

  defaultImageCropData(image, idx) {
    // Autorotate images when aspect ratio does not match target size aspect ratio.
    if (this.shouldAutorotate(this.printProducts[idx], image)) {
      return '{r:90}';
    } else {
      return null;
    }
  }

  imageValueForSize(guid, idx) {
    const values = this.state.image_values.get(idx);
    const image = this.uploadedImages.find(image => image.guid === guid);
    let value = values && values.get(guid);
    if (!value) {
      value = `db:${image.id}`;
      const crop_data = this.defaultImageCropData(image, idx);
      if (crop_data) {
        value += `@${crop_data}`;
      }
    }
    return value;
  }

  isImageFitToShrink(guid, idx) {
    const value = this.imageValueForSize(guid, idx);
    const value_dict = Px.CMS.Helpers.parseImageValue(value);
    const crop_data = value_dict.crop_data;
    return crop_data && crop_data.z && crop_data.z < 0;
  }

  imageQuantityForSize(guid, idx) {
    const selections = this.state.size_selections.get(idx);
    return selections ? (selections.get(guid) || 0) : 0;
  }

  imageTotalQuantity(guid) {
    let total = 0;
    this.printProducts.forEach((_, idx) => {
      total += this.imageQuantityForSize(guid, idx);
    });
    return total;
  }

  sizeTotalQuantity(idx) {
    const selections = this.state.size_selections.get(idx);
    let total = 0;
    if (selections) {
      for (const qty of selections.values()) {
        total += qty;
      }
    }
    return total;
  }

  currentSelectionQuantitiesForSize(idx) {
    return this.state.selected_images.map(guid => this.imageQuantityForSize(guid, idx));
  }

  currentSelectionTotalQuantityForSize(idx) {
    let total = 0;
    this.currentSelectionQuantitiesForSize(idx).forEach(qty => {
      total += qty;
    });
    return total;
  }

  currentSelectionDisplayQuantityForSize(idx) {
    const selection = this.currentSelectionQuantitiesForSize(idx);
    const unique_count = (new Set(selection)).size;
    if (unique_count === 0) {
      return 0;
    } else if (unique_count === 1) {
      return selection[0];
    } else {
      return '*';
    }
  }

  unitPrice(idx) {
    const pricing_data = this.state.pricing_data.length ? this.state.pricing_data[idx] : null;
    if (!pricing_data) {
      return 0;
    }
    return pricing_data.price / pricing_data.parameters.cut_print_quantity;
  }

  optionsForDisplay(idx) {
    const variants_for_display = this._collectOptionsForDisplay(
      'variant', idx, this.printProducts[idx].variants
    );

    const template_options_for_display = this._collectOptionsForDisplay(
      'template_option', idx, this.printProducts[idx].template_options
    );

    return variants_for_display.concat(template_options_for_display);
  }

  _collectOptionsForDisplay(type, size_idx, options) {
    let collected = [];

    options.forEach(option => {
      if (option.type === 'multiple_choice') {
        collected.push([type, option]);

        const selected_value = this.optionValueForSize(type, size_idx, option);
        if (selected_value) {
          const option_value = option.values.find(val => val.code === selected_value);
          if (option_value) {
            const triggered_children = option.children.filter(child => child.trigger_value_id === option_value.id);
            collected = collected.concat(this._collectOptionsForDisplay(type, size_idx, triggered_children));
          }
        }
      }
    });

    return collected;
  }

  hasOptionsForSize(size_idx) {
    return this.sizeTotalQuantity(size_idx) > 0 && this.optionsForDisplay(size_idx).length > 0;
  }

  variantParameters(size_idx) {
    const variants = {};
    if (this.state.variant_selections.has(size_idx)) {
      this.state.variant_selections.get(size_idx).forEach((value, key) => {
        variants[key] = value;
      });
    }
    return variants;
  }

  templateOptionParameters(size_idx) {
    const template_options = {};
    if (this.state.template_option_selections.has(size_idx)) {
      this.state.template_option_selections.get(size_idx).forEach((value, key) => {
        template_options[key] = value;
      });
    }
    return template_options;
  }

  // --------------
  // Event handlers
  // --------------

  mobileModeListener(evt) {
    this.state.mobile_mode = evt.matches;
  }

  triggerUploadDialog(evt) {
    if (document.querySelector('px-upload-dialog')) {
      // An upload dialog already exists.
      return;
    }

    const upload_guid = Px.Util.guid();

    const dialog = document.createElement('px-upload-dialog');
    dialog.setAttribute('multiple', '');
    dialog.setAttribute('sources', this.data.image_sources);
    dialog.setAttribute('button-class', 'btn btn-xs');
    dialog.setAttribute('source-button-class', 'btn-outline-secondary');
    dialog.setAttribute('local-source-button-class', 'btn-primary');
    dialog.setAttribute('confirm-button-class', 'btn-secondary');
    dialog.setAttribute('picker-load-more-button-class', 'btn-xxs btn-outline-secondary');
    dialog.setAttribute('google-photos-picker-link-button-class', 'btn-primary');

    if (this.data.dropbox_app_key) {
      dialog.setAttribute('dropbox-app-key', this.data.dropbox_app_key);
    }
    if (this.data.google_client_id) {
      dialog.setAttribute('google-client-id', this.data.google_client_id);
    }

    Object.keys(this.data.texts).forEach(key => {
      if (key.startsWith('upload-dialog-')) {
        dialog.setAttribute(key.replace(/^upload-dialog-/, ''), this.data.texts[key]);
      }
    });

    dialog.addEventListener('upload-start', this.handleUploadChange.bind(this, upload_guid));
    dialog.addEventListener('upload-progress', this.handleUploadChange.bind(this, upload_guid));
    dialog.addEventListener('upload-error', this.handleUploadChange.bind(this, upload_guid));
    dialog.addEventListener('upload-success', this.handleUploadChange.bind(this, upload_guid));

    document.body.appendChild(dialog);
  }

  toggleSingleImageSelected(guid) {
    this.state.last_selected_range = null;

    if (this.state.selected_images.includes(guid)) {
      this.state.selected_images.remove(guid);
      this.state.autoselect_all = false;
    } else {
      this.state.selected_images.push(guid);
    }
  }

  toggleImageRangeSelected(guid) {
    const image = this.uploadedImages.find(i => i.guid === guid);

    if (this.state.selected_images.length === 0) {
      // Select everything up to the clicked image.
      const end_idx = this.uploadedImages.indexOf(image);
      for (let idx = 0; idx <= end_idx; idx++) {
        this.state.selected_images.push(this.uploadedImages[idx].guid);
      }
      this.state.last_selected_range = [0, end_idx];
      return;
    }

    let image_a;
    const last_range = this.state.last_selected_range;
    if (last_range) {
      image_a = this.uploadedImages[last_range[0]];
      // Clear previously selected range.
      const idx_min = Math.min(last_range[0], last_range[1]);
      const idx_max = Math.max(last_range[0], last_range[1]);
      this.uploadedImages.forEach((image, idx) => {
        if (idx >= idx_min && idx <= idx_max) {
          this.state.selected_images.remove(image.guid);
        }
      });
    } else {
      const last_selected_image_guid = this.state.selected_images[this.state.selected_images.length - 1];
      image_a = this.uploadedImages.find(image => image.guid === last_selected_image_guid);
    }

    const idx_a = this.uploadedImages.indexOf(image_a);
    const idx_b = this.uploadedImages.indexOf(image);
    const idx_min = Math.min(idx_a, idx_b);
    const idx_max = Math.max(idx_a, idx_b);

    this.uploadedImages.forEach((image, idx) => {
      if (idx >= idx_min && idx <= idx_max) {
        if (!this.state.selected_images.includes(image.guid)) {
          this.state.selected_images.push(image.guid);
        }
      }
    });

    this.state.last_selected_range = [idx_a, idx_b];
  }

  toggleImageSelection(evt) {
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    mobx.runInAction(() => {
      if (this.state.reset_selection_process) {
        this.state.selected_images.clear();
        this.state.last_selected_range = null;
        this.state.reset_selection_process = false;
      }
      if (evt.shiftKey) {
        this.toggleImageRangeSelected(guid);
      } else {
        this.toggleSingleImageSelected(guid);
      }
    });
  }

  toggleAutoselect(evt) {
    mobx.runInAction(() => {
      if (this.state.autoselect_all) {
        this.state.autoselect_all = false;
        this.state.selected_images.clear();
      } else {
        this.state.autoselect_all = true;
        this.state.selected_images.replace(this.uploadedImages.map(image => image.guid));
      }
      this.state.reset_selection_process = false;
    });
  }

  preventDefault(evt) {
    evt.preventDefault();
  }

  focusImageOnLongPress(evt) {
    if (!this.state.mobile_mode) {
      return;
    }

    if (evt.targetTouches.length > 1) {
      return;
    }

    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');

    let timeout;

    const cancel = (evt) => {
      clearTimeout(timeout);
      document.removeEventListener('touchcancel', cancel);
      document.removeEventListener('touchend', cancel);
      document.removeEventListener('touchleave', cancel);
      document.removeEventListener('touchmove', cancel);
    };

    document.addEventListener('touchcancel', cancel);
    document.addEventListener('touchend', cancel);
    document.addEventListener('touchleave', cancel);
    document.addEventListener('touchmove', cancel);

    timeout = setTimeout(() => {
      this.state.focused_image_guid = guid;
      cancel();
    }, Px.Util.longPressDuration);
  }

  unfocusImage(evt) {
    this.state.focused_image_guid = null;
  }

  removeImage(evt) {
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const [upload_guid, image_id] = guid.split(':');

    const modal = Px.Components.BaseModal.make({
      content: this.getText('delete-image-confirmation'),
      css_class: 'px-photo-prints',
      render_close_button: false,
      footer: Px.template`
        <button class="px-btn px-btn-secondary" data-onclick="close">
          ${this.getText('delete-image-cancel-button-text')}
        </button>
        <button class="px-btn px-btn-primary" data-onclick="onConfirm">
          ${this.getText('delete-image-confirm-button-text')}
        </button>
      `,
      event_handlers: {
        onConfirm: evt => {
          mobx.runInAction(() => {
            const uploads = this.state.uploads.get(upload_guid);
            const upload = uploads.find(u => u.result.id.toString() === image_id);
            uploads.remove(upload);
            this.state.selected_images.remove(guid);
            this.state.focused_image_guid = null;
            for (const [idx, selection] of this.state.size_selections) {
              selection.delete(guid);
            }
          });
          modal.close();
        }
      }
    });
    modal.mount(document.body);
  }

  removePrint(evt) {
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const size_idx = parseInt(evt.target.closest('[data-size-idx]').getAttribute('data-size-idx'), 10);

    const modal = Px.Components.BaseModal.make({
      content: this.getText('delete-print-confirmation'),
      css_class: 'px-photo-prints',
      render_close_button: false,
      footer: Px.template`
        <button class="px-btn px-btn-secondary" data-onclick="close">
          ${this.getText('delete-print-cancel-button-text')}
        </button>
        <button class="px-btn px-btn-primary" data-onclick="onConfirm">
          ${this.getText('delete-print-confirm-button-text')}
        </button>
      `,
      event_handlers: {
        onConfirm: evt => {
          mobx.runInAction(() => {
            this.state.size_selections.get(size_idx).delete(guid);
            this.resetCropState();
          });
          modal.close();
        }
      }
    });
    modal.mount(document.body);
  }

  toggleShrinkToFit(evt) {
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const size_idx = parseInt(evt.target.closest('[data-size-idx]').getAttribute('data-size-idx'), 10);
    const subcomponent_key = this.imageAdjustToolComponentKey(guid, size_idx, 'inline');
    this.subcomponents[subcomponent_key].toggleShrinkToFit(evt);
  }

  openCropTool(evt) {
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const size_idx = parseInt(evt.target.closest('[data-size-idx]').getAttribute('data-size-idx'), 10);
    mobx.runInAction(() => {
      this.state.crop_image_guid = guid;
      this.state.crop_size_idx = size_idx;
    });
  }

  // This is only used on mobile where clicking anywhere on the overlay saves crop and closes the overlay.
  // On desktop we use the Cancel/Done buttons instead.
  closeCroppingTool(evt) {
    if (this.state.mobile_mode) {
      this.resetCropState();
    }
  }

  setPhotoSelectionThumbSize(evt) {
    this.state.thumbnail_size_photo_selection = evt.target.closest('[data-size]').getAttribute('data-size');
  }

  setCropOptionsThumbSize(evt) {
    this.state.thumbnail_size_crop_options = evt.target.closest('[data-size]').getAttribute('data-size');
  }

  goToCropOptions(evt) {
    if (this.state.mobile_mode && this.totalPrintsQuantity === 0) {
      this.state.bottom_bar_open = true;
    } else {
      mobx.runInAction(() => {
        this.state.screen = 'crop-options';
        this.state.is_transitioning_to_cropping_and_options = true;
      });
      // We set up a 600ms "transition" time during which the add to cart button is disabled,
      // so that double-clicking the "Cropping & Options" button doesn't accidentally add to cart.
      setTimeout(() => {
        this.state.is_transitioning_to_cropping_and_options = false;
      }, 600);
    }
  }

  goToPhotoSelection(evt) {
    this.state.screen = 'photo-selection';
  }

  toggleBottomBar(evt) {
    this.state.bottom_bar_open = !this.state.bottom_bar_open;
  }

  async addToCart(evt) {
    this.state.is_adding_to_cart = true;

    if (this.data.project_id) {
      const project = await this.updateLoadedProject();
      if (!this.data.cart_mode) {
        await this.addProjectToCart(project, this.printProducts[0]);
      } else if (this.externalIntegration.updateCartItem) {
        await this.externalIntegration.updateCartItem(project, this.printProducts[0]);
      }
    } else {
      const items = await this.createProjects();
      for (const item of items) {
        await this.addProjectToCart(item.project, item.print_product);
        this.state.add_to_cart_steps_completed += 1;
      }
    }

    this.removeStateFromSession();

    if (this.externalIntegration.goToCart) {
      return this.externalIntegration.goToCart();
    }

    window.location = this.data.cart_page;
  }

  handleUploadChange(upload_guid, evt) {
    this.state.uploads.set(upload_guid, evt.detail.files);
    // Auto-select any new upload and set current sizes.
    if (this.state.autoselect_all) {
      this.uploadedImages.forEach(image => {
        if (!this.state.selected_images.includes(image.guid)) {
          this.state.selected_images.push(image.guid);
          this.printProducts.forEach((_, idx) => {
            const quantities = this.currentSelectionQuantitiesForSize(idx);
            if (quantities.length > 0) {
              // TODO: If there is more than one quantity, use the most frequent one?
              this.setImageQuantityForSize(image.guid, quantities[0], idx);
            }
          });
        }
      });
    }
  }

  massIncreaseQuantity(evt) {
    const idx = parseInt(evt.target.closest('[data-idx]').getAttribute('data-idx'), 10);
    const quantities_per_image = this.state.size_selections.get(idx) || new Map();
    mobx.runInAction(() => {
      this.state.selected_images.forEach(guid => {
        const current_quantity = quantities_per_image.get(guid) || 0;
        this.setImageQuantityForSize(guid, current_quantity + 1, idx);
      });
      this.state.reset_selection_process = true;
    });
  }

  massDecreaseQuantity(evt) {
    const idx = parseInt(evt.target.closest('[data-idx]').getAttribute('data-idx'), 10);
    const quantities_per_image = this.state.size_selections.get(idx);
    if (!quantities_per_image) {
      return;
    };
    mobx.runInAction(() => {
      this.state.selected_images.forEach(guid => {
        const current_quantity = quantities_per_image.get(guid);
        this.setImageQuantityForSize(guid, current_quantity - 1, idx);
      });
      this.state.reset_selection_process = true;
    });
  }

  massPromptQuantity(evt) {
    const idx = parseInt(evt.target.closest('[data-idx]').getAttribute('data-idx'), 10);
    const new_qty = parseInt(prompt(this.getText('quantity-prompt')), 10);
    if (new_qty) {
      mobx.runInAction(() => {
        this.state.selected_images.forEach(guid => {
          this.setImageQuantityForSize(guid, new_qty, idx);
        });
        this.state.reset_selection_process = true;
      });
    }
  }

  increaseQuantity(evt) {
    const idx = parseInt(evt.target.closest('[data-size-idx]').getAttribute('data-size-idx'), 10);
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const current_quantity = this.state.size_selections.get(idx).get(guid);
    this.setImageQuantityForSize(guid, current_quantity + 1, idx);
  }

  decreaseQuantity(evt) {
    const idx = parseInt(evt.target.closest('[data-size-idx]').getAttribute('data-size-idx'), 10);
    const guid = evt.target.closest('[data-guid]').getAttribute('data-guid');
    const current_quantity = this.state.size_selections.get(idx).get(guid);
    this.setImageQuantityForSize(guid, current_quantity - 1, idx);
  }


  storeOptionValue(type, size_idx, option_code, value) {
    let selections;
    if (type === 'template_option') {
      if (!this.state.template_option_selections.has(size_idx)) {
        this.state.template_option_selections.set(size_idx, mobx.observable.map());
      }
      selections = this.state.template_option_selections.get(size_idx);
    } else {
      if (!this.state.variant_selections.has(size_idx)) {
        this.state.variant_selections.set(size_idx, mobx.observable.map());
      }
      selections = this.state.variant_selections.get(size_idx);
    }
    selections.set(option_code, value);
  }

  storeOptionValueFromSelect(evt) {
    const select = evt.target.closest('select');
    const type = select.getAttribute('data-type');
    const size_idx = parseInt(select.getAttribute('data-size-idx'), 10);
    const option_code = select.getAttribute('data-code');
    const selected_value = select.value;

    this.storeOptionValue(type, size_idx, option_code, selected_value);
  }

  storeOptionValueFromRadioButton(evt) {
    const wrapper = evt.target.closest('[data-type]');
    const type = wrapper.getAttribute('data-type');
    const size_idx = parseInt(wrapper.getAttribute('data-size-idx'), 10);
    const option_code = evt.target.getAttribute('data-code');
    const selected_value = evt.target.value;

    this.storeOptionValue(type, size_idx, option_code, selected_value);
  }

  thumbnailPixelSize(thumbnail_string_size) {
    switch (thumbnail_string_size) {
    case 'single':
      return 900;
    case 'large':
      return 250;
    default:
      return 150;
    }
  }

  showDescriptionPopover(evt) {
    if (!evt.target.matches('.px-info-bubble')) {
      return;
    }
    const rect = evt.target.getBoundingClientRect();
    const offset = 15;
    const left = rect.left - offset;
    const top = rect.top - offset;
    const popover = evt.target.nextElementSibling;
    popover.style.left = `${left}px`;
    popover.style.top = `${top}px`;
    popover.showPopover();
  }

  hideDescriptionPopover(evt) {
    if (!evt.target.matches('.px-info-bubble')) {
      return;
    }
    const popover = evt.target.nextElementSibling;
    popover.hidePopover();
  }

  // -------
  // Private
  // -------

  loadThemes() {
    mobx.runInAction(() => {
      const theme_store = this.state.theme_store;
      this.designProducts.forEach(design_product => {
        const theme_id = design_product.theme_id;
        if (!theme_store.has(theme_id)) {
          // Set the value to `null` first, trigger XHR to the API, and once we get back a response,
          // replace the `null` values with the actual API json response.
          theme_store.set(theme_id, null);
          this.loadTheme(theme_id);
        }
      });
    });
  }

  async loadTheme(theme_id) {
    const json = await fetch(`/v1/themes/${theme_id}.json`).then(r => r.json());
    const page_node = this.getPrintPageNode(json);
    const image_node = this.getPlaceholderImageNode(page_node);
    const width = image_node.getAttribute('width');
    const height = image_node.getAttribute('height');
    json.crop_aspect_ratio_float = width / height;
    json.crop_aspect_ratio = `${width}mm/${height}mm`;
    this.state.theme_store.set(theme_id, json);
  }

  getPrintPageName(theme_json) {
    const layout_node = Px.Util.parseXML(theme_json.print_product.layout).firstChild;
    // TODO: We skip non-editor pages here, but what else needs to be done to properly support editor="false" pages?
    // TODO: Do we still support type="page1,page2"-style template page names?
    const page = Array.from(layout_node.querySelectorAll('set:not([editor="false"]) page'))[0];
    return page.getAttribute('type');
  }

  getPrintPageNode(theme_json) {
    const template_name = this.getPrintPageName(theme_json);
    const template_json = theme_json.templates.find(template => template.print_page.name === template_name);
    const page_node = Px.Util.parseXML(template_json.print_page.data).firstChild;
    return page_node;
  }

  getPlaceholderImageNode(page_node) {
    return this.getPlaceholderImageNodes(page_node)[0];
  }

  getPlaceholderImageNodes(page_node) {
    // The proper way to mark placeholder nodes for photo print fulfillment is to give them the name "photo-print".
    // For backwards compatibility, if no "photo-print" images are found, we take the first editable placeholder.
    const nodes = Array.from(page_node.querySelectorAll('image[edit="true"][placeholder="true"][name="photo-print"]'));
    if (nodes.length === 0) {
      nodes.push(page_node.querySelector('image[edit="true"][placeholder="true"]'));
    }
    return nodes;
  }

  async loadProject() {
    const json = await fetch(`/v1/books/${this.data.project_id}.json`).then(r => r.json());

    const data = this.extractProjectData(json);
    this._project_data = data;

    mobx.runInAction(() => {
      data.forEach(page_data => {
        this.state.uploads.set(page_data.upload_guid, [page_data.file]);
      });
      this.state.autoselect_all = true;
      this.state.selected_images.replace(this.uploadedImages.map(image => image.guid));
      const quantities_per_image = mobx.observable.map();
      this.uploadedImages.forEach((image, idx) => {
        quantities_per_image.set(image.guid, data[idx].quantity);
      });
      this.state.size_selections.set(0, quantities_per_image);
      const values_per_image = mobx.observable.map();
      this.uploadedImages.forEach((image, idx) => {
        values_per_image.set(image.guid, data[idx].image_value);
      });
      this.state.image_values.set(0, values_per_image);
      const variant_selections = mobx.observable.map();
      Object.keys(json.options).forEach(key => {
        variant_selections.set(key, json.options[key]);
      });
      this.state.variant_selections.set(0, variant_selections);
      const template_option_selections = mobx.observable.map();
      Object.keys(json.template_options).forEach(key => {
        template_option_selections.set(key, json.template_options[key]);
      });
      this.state.template_option_selections.set(0, template_option_selections);
      this.state.screen = 'photo-selection';
    });
  }

  extractProjectData(project_json) {
    const project_data = [];

    project_json.layout.pages.set.forEach(page_set => {
      if (page_set.editor) {
        page_set.print_page.forEach(page => {
          const page_node = Px.Util.parseXML(page.data).firstChild;

          const quantity = parseInt(page_node.getAttribute('quantity'), 10) || 1;

          let image_node = page_node.querySelector('image[edit="true"][name="photo-print"]');
          if (!image_node) {
            // For backwards-compatibility.
            image_node = page_node.querySelector('image[edit="true"]');
          }

          const image_id = parseInt(image_node.getAttribute('src').split(':')[1], 10);

          let image_value = `db:${image_id}`;
          const crop_data = [];
          const left = parseFloat(image_node.getAttribute('left'));
          const top = parseFloat(image_node.getAttribute('top'));
          const zoom = parseFloat(image_node.getAttribute('zoom'));
          const crotation = parseFloat(image_node.getAttribute('crotation'));
          if (left) {
            crop_data.push(`l:${left}`);
          }
          if (top) {
            crop_data.push(`t:${top}`);
          }
          if (zoom) {
            crop_data.push(`z:${zoom}`);
          }
          if (crotation) {
            crop_data.push(`r:${crotation}`);
          }
          if (crop_data.length) {
            image_value += '@{' + crop_data.join(',') + '}';
          }

          const image_api_hash = project_json.images.find(i => i.id === image_id);

          // We cannot use a single upload guid because the same image may be used
          // multiple times and we need `upload_id:image_id` to be globally unique,
          // so create a separate "upload" for each page.
          const upload_guid = `${this.LOADED_PROJECT_UPLOAD_GUID_PREFIX}/${page.id}`;

          project_data.push({
            page_id: page.id,
            quantity: quantity,
            image_value: image_value,
            upload_guid: upload_guid,
            // Make it look like an upload.
            file: {
              progress: {
                lengthComputable: false,
                loaded: 0,
                total: 0
              },
              error: null,
              result: image_api_hash
            }
          });
        });
      }
    });

    return project_data;
  }

  imageAdjustToolComponentKey(image_guid, size_idx, suffix) {
    const key = `image-adjust-${image_guid}-${size_idx}`;
    if (suffix) {
      return `${key}-${suffix}`;
    }
    return key;
  }

  imageAdjustToolComponentProps(image, size_idx, inline_mode) {
    let thumbnail_size;
    if (inline_mode) {
      thumbnail_size = this.thumbnailPixelSize(this.state.thumbnail_size_crop_options);
    } else {
      thumbnail_size = this.state.mobile_mode ? 600 : 1200;
    }

    const texts = {};
    Object.keys(this.data.texts).forEach(key => {
      if (key.startsWith('image-adjust-tool-')) {
        texts[key.replace(/^image-adjust-tool-/, '')] = this.data.texts[key];
      }
    });

    return {
      value: this.imageValueForSize(image.guid, size_idx),
      image_src: this.getThumbnailUrlForSize(image, thumbnail_size),
      image_width: image.width,
      image_height: image.height,
      default_crop_data: this.defaultImageCropData(image, size_idx),
      crop_aspect_ratio: this.cropAspectRatioForSize(size_idx),
      shrink_to_fit_enabled: true,
      minimum_dpi: this.printProducts[size_idx].theme.print_product.minimum_dpi,
      rotation_mode: 'placeholder',
      button_class: 'px-btn px-btn-secondary',
      cancel_button_class: 'px-cancel-button',
      submit_button_class: 'px-btn-primary',
      texts: texts,
      onChange: value => (this.state.mobile_mode || inline_mode) ? this.saveCrop(image, size_idx, value) : null,
      onCancel: () => this.resetCropState(),
      onSubmit: value => this.saveCropAndClose(image, size_idx, value)
    };
  }

  getThumbnailUrlForSize(image, size_pixels) {
    let best_match = image.thumbnails[0].url;
    for (let idx = 1; idx < image.thumbnails.length; idx++) {
      if (image.thumbnails[idx].size <= size_pixels) {
        best_match = image.thumbnails[idx].url;
      }
    }
    return best_match;
  }

  setImageQuantityForSize(guid, quantity, idx) {
    mobx.runInAction(() => {
      let quantities_per_image = this.state.size_selections.get(idx);
      if (!quantities_per_image) {
        quantities_per_image = mobx.observable.map();
        this.state.size_selections.set(idx, quantities_per_image);
      }
      // TODO: Max limits?
      quantities_per_image.set(guid, Math.max(0, quantity));
    });
  }

  resetCropState() {
    mobx.runInAction(() => {
      this.state.crop_image_guid = null;
      this.state.crop_size_idx = 0;
    });
  }

  saveCrop(image, size_idx, value) {
    mobx.runInAction(() => {
      if (!this.state.image_values.has(size_idx)) {
        this.state.image_values.set(size_idx, mobx.observable.map());
      }

      this.state.image_values.get(size_idx).set(image.guid, value);
    });
  }

  saveCropAndClose(image, size_idx, value) {
    mobx.runInAction(() => {
      this.saveCrop(image, size_idx, value);
      this.resetCropState();
    });
  }

  optionValueForSize(type, size_idx, option) {
    let selections;
    if (type === 'template_option') {
      selections = this.state.template_option_selections.get(size_idx);
    } else {
      selections = this.state.variant_selections.get(size_idx);
    }
    if (selections && selections.has(option.code)) {
      return selections.get(option.code);
    }
    const default_value = option.values.find(val => val.is_default);
    if (default_value) {
      return default_value.code;
    }
    if (option.is_required && option.values[0]) {
      return option.values[0].code;
    }
    return '';
  }

  addProjectToCart(project, print_product) {
    if (this.externalIntegration.addProjectToCart) {
      return this.externalIntegration.addProjectToCart(project, print_product);
    }

    return fetch('/cart/add_print_product', {
      method: 'POST',
      body: new URLSearchParams({
        print_book_id: project.id
      })
    });
  }

  createProjects() {
    const promises = [];

    this.printProducts.forEach((print_product, idx) => {
      const print_pages = this.makePrintPagesForSize(idx);
      if (print_pages.length > 0) {
        this.state.add_to_cart_total_projects += 1;

        const book_params = {
          product_id: print_product.product_id,
          theme_id: print_product.theme.id
        };

        if (this.externalIntegration.createProjectExtraParams) {
          Object.assign(book_params, this.externalIntegration.createProjectExtraParams(print_product));
        }

        const promise = fetch('/v1/books.json', {
          method: 'POST',
          body: new URLSearchParams(book_params)
        }).then(r => r.json()).then(book => {
          this.state.add_to_cart_steps_completed += 1;

          const updates = {
            deleted_pages: [],
            new_pages: [],
            variants: this.variantParameters(idx),
            template_options: this.templateOptionParameters(idx)
          };

          // Cut print projects start with one blank page. Make sure to remove it.
          const page_set = book.layout.pages.set.find(s => s.editor);
          page_set.print_page.forEach(page => {
            updates.deleted_pages.push(page.id);
          });

          print_pages.forEach(page => {
            updates.new_pages.push({
              body: page,
              name: page_set.print_page[0].name
            });
          });

          return this.updateProjectAPI(book.id, updates);
        }).then(r => {
          this.state.add_to_cart_steps_completed += 1;

          return r.json();
        }).then(json => {
          return {project: json, print_product: print_product};
        });

        promises.push(promise);
      }
    });

    return Promise.all(promises);
  }

  updateLoadedProject() {
    // Gather changes to existing project pages (which pages to delete, which to update).
    const deleted_pages = [];
    const updated_pages = [];
    this._project_data.forEach(page_data => {
      const idx = this.uploadedImages.findIndex(i => i.guid.startsWith(`${page_data.upload_guid}:`));
      const uploaded_image = this.uploadedImages[idx];
      if (idx !== -1) {
        const new_qty = this.imageQuantityForSize(uploaded_image.guid, 0);
        if (new_qty === 0) {
          deleted_pages.push(page_data.page_id);
        } else {
          const new_image_value = this.imageValueForSize(uploaded_image.guid, 0);
          if (new_qty !== page_data.quantity || new_image_value !== page_data.image_value) {
            updated_pages.push({
              id: page_data.page_id,
              body: this.makePrintPageForSize(0, uploaded_image)
            });
          }
        }
      } else {
        deleted_pages.push(page_data.page_id);
      }
    });

    // Gather new pages.
    const new_pages = [];
    const page_name = this.getPrintPageName(this.printProducts[0].theme);
    this.uploadedImages.forEach(image => {
      if (!image.guid.startsWith(this.LOADED_PROJECT_UPLOAD_GUID_PREFIX)) {
        if (this.imageQuantityForSize(image.guid, 0) > 0) {
          new_pages.push({
            name: page_name,
            body: this.makePrintPageForSize(0, image)
          });
        }
      }
    });

    const updates = {
      deleted_pages: deleted_pages,
      updated_pages: updated_pages,
      new_pages: new_pages,
      variants: this.variantParameters(0),
      template_options: this.templateOptionParameters(0)
    };

    return this.updateProjectAPI(this.data.project_id, updates).then(r => r.json());
  }

  updateProjectAPI(project_id, updates) {
    const params = new URLSearchParams();

    (updates.deleted_pages || []).forEach(page_id => {
      params.append('book[deleted_pages][]', page_id);
    });

    (updates.updated_pages || []).forEach(page => {
      params.append(`book[pages][${page.id}]`, page.body);
    });

    (updates.new_pages || []).forEach(new_page => {
      const key = `new:${Px.Util.guid()}`;
      params.append(`book[pages][${key}]`, new_page.body);
      params.append(`book[page_meta][${key}][name]`, new_page.name);
    });

    Object.keys(updates.variants || {}).forEach(key => {
      params.append(`book[options][${key}]`, updates.variants[key]);
    });

    Object.keys(updates.template_options || {}).forEach(key => {
      params.append(`book[template_options][${key}]`, updates.template_options[key]);
    });

    params.append('perform_element_substitutions', 'true');

    return fetch(`/v1/books/${project_id}.json`, {
      method: 'PUT',
      body: params
    });
  }

  makePrintPagesForSize(idx) {
    const print_pages = [];
    this.uploadedImages.forEach(image => {
      const print_page = this.makePrintPageForSize(idx, image);
      if (print_page) {
        print_pages.push(print_page);
      }
    });
    return print_pages;
  }

  makePrintPageForSize(idx, image) {
    const print_product = this.printProducts[idx];
    const page_node = this.getPrintPageNode(print_product.theme);
    const size_selections = this.state.size_selections.get(idx);
    if (size_selections) {
      const qty = size_selections.get(image.guid);
      if (qty > 0) {
        const page_node_clone = page_node.cloneNode(true);
        if (qty !== 1) {
          page_node_clone.setAttribute('quantity', qty);
        }
        const image_value = this.imageValueForSize(image.guid, idx);
        const value_dict = Px.CMS.Helpers.parseImageValue(image_value);
        this.getPlaceholderImageNodes(page_node_clone).forEach(image_node => {
          image_node.setAttribute('src', `db:${value_dict.image_id}`);
          image_node.removeAttribute('placeholder');
          const crop_data = value_dict.crop_data;
          if (crop_data) {
            Object.keys(crop_data).forEach(key => {
              const val = crop_data[key];
              if (val !== 0) {
                const name = {l: 'left', t: 'top', z: 'zoom', r: 'crotation'}[key];
                image_node.setAttribute(name, val);
              }
            });
            if (crop_data.r && Px.Util.roundToNearest(crop_data.r, 90) === 90) {
              if (this.shouldAutorotate(print_product, image)) {
                image_node.setAttribute('tags', 'px:autorotated');
              }
            }
          }
        });
        return Px.Util.serializeXML(page_node_clone);
      }
    }
    return null;
  }

  async fetchPrices(variables) {
    // Abort any in-flight request.
    this._fetch_price_abort_controllers.forEach((controller, idx) => controller.abort());
    this._fetch_price_abort_controllers = [];

    if (variables) {
      const promises = [];

      for (let idx = 0; idx < variables.length; idx++) {
        const vars = variables[idx];
        const search_params = new URLSearchParams();
        search_params.append('theme_id', vars.theme_id);
        search_params.append('cut_print_quantity', vars.cut_print_quantity || 1);
        Object.keys(vars.variants).forEach(key => {
          search_params.append(`variants[${key}]`, vars.variants[key]);
        });
        Object.keys(vars.template_options).forEach(key => {
          search_params.append(`template_options[${key}]`, vars.template_options[key]);
        });
        const url = `/v1/products/${vars.product_id}/price_forecast.json?${search_params}`;
        this._fetch_price_abort_controllers[idx] = new AbortController();
        const opts = {
          signal: this._fetch_price_abort_controllers[idx].signal
        };
        const promise = fetch(url, opts).then(r => r.json());
        promises.push(promise);
      }

      try {
        if (promises.length > 0) {
          const data = await Promise.all(promises);
          let total = 0;
          data.forEach((pricing, idx) => {
            if (variables[idx].cut_print_quantity > 0) {
              total += pricing.price;
            }
          });
          mobx.runInAction(() => {
            this.state.pricing_data.replace(data);
            this.state.total_price = total;
          });
        } else {
          mobx.runInAction(() => {
            this.state.pricing_data.clear();
            this.state.total_price = null;
          });
        }
      } catch (err) {
        if (err.name === 'AbortError') {
          console.debug('product_forecast fetch aborted');
        } else {
          mobx.runInAction(() => {
            this.state.pricing_data.clear();
            this.state.total_price = null;
          });
          console.error(err);
        }
      }

    } else {
      mobx.runInAction(() => {
        this.state.pricing_data.clear();
        this.state.total_price = null;
      });
    }
  }

};

Px.CMS.PhotoPrintsComponent.DEFAULT_TEXTS = {
  'add-photos-short': 'Add photos',
  'add-photos-long': 'Add more photos',
  'select-photos': 'Select photos',
  'photo-count': '{{count}} photos',
  'photo-count-one': '{{count}} photo',
  'photo-count-other': '{{count}} photos',
  'photos-selected-count': '{{count}} selected',
  'add-to-cart': 'Add to Cart',
  'save-to-cart': 'Save to Cart',
  'next': 'Next',
  'cropping-and-options': 'Cropping & Options',
  'select-all': 'Select all',
  'deselect-all': 'Deselect all',
  'select-sizes': 'Select Sizes',
  'no-images-selected': 'No images are selected.',
  'delete-image': 'Delete image',
  'delete-image-confirmation': 'Really delete image?',
  'delete-image-confirm-button-text': 'Confirm',
  'delete-image-cancel-button-text': 'Cancel',
  'print-sizes': 'Print Sizes',
  'print-size-selection-instructions': 'Adjust the number of prints for each desired size using the plus or minus buttons.',
  'back': 'Back',
  'total-prints-count': '{{count}} prints total',
  'select-options': 'Select Options',
  'product-options': 'Product Options',
  'option-selection-instructions': 'Choose options for each selected size.',
  'delete-print': 'Delete print',
  'delete-print-confirmation': 'Really delete print?',
  'delete-print-confirm-button-text': 'Confirm',
  'delete-print-cancel-button-text': 'Cancel',
  'please-wait': 'Please wait...',
  'crop-button-title': 'Crop image',
  'shrink-to-fit-button-title': 'Shrink to fit',
  'quantity-prompt': 'Please enter desired quantity:'
};

Px.CMS.PhotoPrintsComponent.icons = {
  cart: '<svg viewBox="0 0 576 512" height="16"><path fill="currentColor" d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H179.9l-9.1-48h317c14.3 0 26.9-9.5 30.8-23.3l54-192C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm336-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"></path></svg>',
  next: '<svg viewBox="0 0 448 512" width="18"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" fill="currentColor"/></svg>',
  back: '<svg viewBox="0 0 448 512" width="18"><g transform-origin="center" transform="rotate(180)"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" fill="currentColor"/></g></svg>',
  add_photos: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 12.5V15H20V16.6667H17.5V19.1667H15.8334V16.6667H13.3334V15H15.8334V12.5H17.5ZM17.5067 2.5C17.9634 2.5 18.3334 2.87083 18.3334 3.3275V11.1183C17.798 10.9292 17.2344 10.8329 16.6667 10.8333V4.16667H3.33335L3.33419 15.8333L11.0775 8.08917C11.2208 7.9454 11.4117 7.85894 11.6143 7.84605C11.8169 7.83316 12.0172 7.89472 12.1775 8.01917L12.2559 8.09L15.21 11.0483C14.5639 11.2452 13.9643 11.5709 13.4475 12.0058C12.9306 12.4407 12.5072 12.9757 12.2027 13.5787C11.8983 14.1816 11.719 14.84 11.6759 15.5141C11.6328 16.1881 11.7266 16.864 11.9517 17.5008L2.49335 17.5C2.27403 17.4998 2.06377 17.4125 1.90876 17.2573C1.75376 17.1022 1.66669 16.8918 1.66669 16.6725V3.3275C1.66821 3.10865 1.75577 2.89918 1.91045 2.74435C2.06512 2.58951 2.2745 2.50175 2.49335 2.5H17.5067ZM6.66669 5.83333C7.10871 5.83333 7.53264 6.00893 7.8452 6.32149C8.15776 6.63405 8.33335 7.05797 8.33335 7.5C8.33335 7.94203 8.15776 8.36595 7.8452 8.67851C7.53264 8.99107 7.10871 9.16667 6.66669 9.16667C6.22466 9.16667 5.80074 8.99107 5.48818 8.67851C5.17561 8.36595 5.00002 7.94203 5.00002 7.5C5.00002 7.05797 5.17561 6.63405 5.48818 6.32149C5.80074 6.00893 6.22466 5.83333 6.66669 5.83333Z" fill="currentColor"/></svg>',
  thumbnails_single: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect width="20" height="20" rx="4" fill="currentColor"/></svg>',
  thumbnails_large: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M1.81836 3.57142C1.81836 3.10643 2.00308 2.66049 2.33187 2.33169C2.66067 2.00289 3.10662 1.81818 3.57161 1.81818H7.0781C7.54309 1.81818 7.98903 2.00289 8.31783 2.33169C8.64663 2.66049 8.83135 3.10643 8.83135 3.57142V7.07792C8.83135 7.54291 8.64663 7.98885 8.31783 8.31765C7.98903 8.64645 7.54309 8.83116 7.0781 8.83116H3.57161C3.10662 8.83116 2.66067 8.64645 2.33187 8.31765C2.00308 7.98885 1.81836 7.54291 1.81836 7.07792V3.57142ZM11.169 3.57142C11.169 3.10643 11.3537 2.66049 11.6825 2.33169C12.0113 2.00289 12.4573 1.81818 12.9223 1.81818H16.4287C16.8937 1.81818 17.3397 2.00289 17.6685 2.33169C17.9973 2.66049 18.182 3.10643 18.182 3.57142V7.07792C18.182 7.54291 17.9973 7.98885 17.6685 8.31765C17.3397 8.64645 16.8937 8.83116 16.4287 8.83116H12.9223C12.4573 8.83116 12.0113 8.64645 11.6825 8.31765C11.3537 7.98885 11.169 7.54291 11.169 7.07792V3.57142ZM1.81836 12.9221C1.81836 12.4571 2.00308 12.0111 2.33187 11.6823C2.66067 11.3535 3.10662 11.1688 3.57161 11.1688H7.0781C7.54309 11.1688 7.98903 11.3535 8.31783 11.6823C8.64663 12.0111 8.83135 12.4571 8.83135 12.9221V16.4286C8.83135 16.8936 8.64663 17.3395 8.31783 17.6683C7.98903 17.9971 7.54309 18.1818 7.0781 18.1818H3.57161C3.10662 18.1818 2.66067 17.9971 2.33187 17.6683C2.00308 17.3395 1.81836 16.8936 1.81836 16.4286V12.9221ZM11.169 12.9221C11.169 12.4571 11.3537 12.0111 11.6825 11.6823C12.0113 11.3535 12.4573 11.1688 12.9223 11.1688H16.4287C16.8937 11.1688 17.3397 11.3535 17.6685 11.6823C17.9973 12.0111 18.182 12.4571 18.182 12.9221V16.4286C18.182 16.8936 17.9973 17.3395 17.6685 17.6683C17.3397 17.9971 16.8937 18.1818 16.4287 18.1818H12.9223C12.4573 18.1818 12.0113 17.9971 11.6825 17.6683C11.3537 17.3395 11.169 16.8936 11.169 16.4286V12.9221Z" fill="currentColor"/></svg>',
  thumbnails_small: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M1.81836 2.98701C1.81836 2.67701 1.9415 2.37972 2.1607 2.16052C2.3799 1.94132 2.6772 1.81818 2.98719 1.81818H5.32485C5.63485 1.81818 5.93214 1.94132 6.15134 2.16052C6.37054 2.37972 6.49368 2.67701 6.49368 2.98701V5.32467C6.49368 5.63466 6.37054 5.93196 6.15134 6.15116C5.93214 6.37036 5.63485 6.4935 5.32485 6.4935H2.98719C2.6772 6.4935 2.3799 6.37036 2.1607 6.15116C1.9415 5.93196 1.81836 5.63466 1.81836 5.32467V2.98701ZM7.66251 2.98701C7.66251 2.67701 7.78566 2.37972 8.00486 2.16052C8.22406 1.94132 8.52135 1.81818 8.83135 1.81818H11.169C11.479 1.81818 11.7763 1.94132 11.9955 2.16052C12.2147 2.37972 12.3378 2.67701 12.3378 2.98701V5.32467C12.3378 5.63466 12.2147 5.93196 11.9955 6.15116C11.7763 6.37036 11.479 6.4935 11.169 6.4935H8.83135C8.52135 6.4935 8.22406 6.37036 8.00486 6.15116C7.78566 5.93196 7.66251 5.63466 7.66251 5.32467V2.98701ZM13.5067 2.98701C13.5067 2.67701 13.6298 2.37972 13.849 2.16052C14.0682 1.94132 14.3655 1.81818 14.6755 1.81818H17.0132C17.3232 1.81818 17.6205 1.94132 17.8397 2.16052C18.0589 2.37972 18.182 2.67701 18.182 2.98701V5.32467C18.182 5.63466 18.0589 5.93196 17.8397 6.15116C17.6205 6.37036 17.3232 6.4935 17.0132 6.4935H14.6755C14.3655 6.4935 14.0682 6.37036 13.849 6.15116C13.6298 5.93196 13.5067 5.63466 13.5067 5.32467V2.98701ZM1.81836 8.83116C1.81836 8.52117 1.9415 8.22387 2.1607 8.00467C2.3799 7.78548 2.6772 7.66233 2.98719 7.66233H5.32485C5.63485 7.66233 5.93214 7.78548 6.15134 8.00467C6.37054 8.22387 6.49368 8.52117 6.49368 8.83116V11.1688C6.49368 11.4788 6.37054 11.7761 6.15134 11.9953C5.93214 12.2145 5.63485 12.3377 5.32485 12.3377H2.98719C2.6772 12.3377 2.3799 12.2145 2.1607 11.9953C1.9415 11.7761 1.81836 11.4788 1.81836 11.1688V8.83116ZM7.66251 8.83116C7.66251 8.52117 7.78566 8.22387 8.00486 8.00467C8.22406 7.78548 8.52135 7.66233 8.83135 7.66233H11.169C11.479 7.66233 11.7763 7.78548 11.9955 8.00467C12.2147 8.22387 12.3378 8.52117 12.3378 8.83116V11.1688C12.3378 11.4788 12.2147 11.7761 11.9955 11.9953C11.7763 12.2145 11.479 12.3377 11.169 12.3377H8.83135C8.52135 12.3377 8.22406 12.2145 8.00486 11.9953C7.78566 11.7761 7.66251 11.4788 7.66251 11.1688V8.83116ZM13.5067 8.83116C13.5067 8.52117 13.6298 8.22387 13.849 8.00467C14.0682 7.78548 14.3655 7.66233 14.6755 7.66233H17.0132C17.3232 7.66233 17.6205 7.78548 17.8397 8.00467C18.0589 8.22387 18.182 8.52117 18.182 8.83116V11.1688C18.182 11.4788 18.0589 11.7761 17.8397 11.9953C17.6205 12.2145 17.3232 12.3377 17.0132 12.3377H14.6755C14.3655 12.3377 14.0682 12.2145 13.849 11.9953C13.6298 11.7761 13.5067 11.4788 13.5067 11.1688V8.83116ZM1.81836 14.6753C1.81836 14.3653 1.9415 14.068 2.1607 13.8488C2.3799 13.6296 2.6772 13.5065 2.98719 13.5065H5.32485C5.63485 13.5065 5.93214 13.6296 6.15134 13.8488C6.37054 14.068 6.49368 14.3653 6.49368 14.6753V17.013C6.49368 17.323 6.37054 17.6203 6.15134 17.8395C5.93214 18.0587 5.63485 18.1818 5.32485 18.1818H2.98719C2.6772 18.1818 2.3799 18.0587 2.1607 17.8395C1.9415 17.6203 1.81836 17.323 1.81836 17.013V14.6753ZM7.66251 14.6753C7.66251 14.3653 7.78566 14.068 8.00486 13.8488C8.22406 13.6296 8.52135 13.5065 8.83135 13.5065H11.169C11.479 13.5065 11.7763 13.6296 11.9955 13.8488C12.2147 14.068 12.3378 14.3653 12.3378 14.6753V17.013C12.3378 17.323 12.2147 17.6203 11.9955 17.8395C11.7763 18.0587 11.479 18.1818 11.169 18.1818H8.83135C8.52135 18.1818 8.22406 18.0587 8.00486 17.8395C7.78566 17.6203 7.66251 17.323 7.66251 17.013V14.6753ZM13.5067 14.6753C13.5067 14.3653 13.6298 14.068 13.849 13.8488C14.0682 13.6296 14.3655 13.5065 14.6755 13.5065H17.0132C17.3232 13.5065 17.6205 13.6296 17.8397 13.8488C18.0589 14.068 18.182 14.3653 18.182 14.6753V17.013C18.182 17.323 18.0589 17.6203 17.8397 17.8395C17.6205 18.0587 17.3232 18.1818 17.0132 18.1818H14.6755C14.3655 18.1818 14.0682 18.0587 13.849 17.8395C13.6298 17.6203 13.5067 17.323 13.5067 17.013V14.6753Z" fill="currentColor"/></svg>',
  toggle_off: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><g clip-path="url(#clip0_156_14)"><path d="M5.625 5C2.86358 5 0.624999 7.23858 0.625 10C0.625 12.7614 2.86358 15 5.625 15C8.38642 15 10.625 12.7614 10.625 10C10.625 7.23858 8.38642 5 5.625 5Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/><path d="M5.625 15L14.375 15C17.1364 15 19.375 12.7614 19.375 10C19.375 7.23858 17.1364 5 14.375 5L5.625 5C2.86358 5 0.624999 7.23858 0.625 10C0.625 12.7614 2.86358 15 5.625 15Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/></g><defs><clipPath id="clip0_156_14"><rect width="20" height="20" fill="white" transform="translate(20 20) rotate(180)"/></clipPath></defs></svg>',
  toggle_on: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M14.375 4.375H5.625C2.52344 4.375 0 6.89844 0 10C0 13.1016 2.52344 15.625 5.625 15.625H14.375C17.4766 15.625 20 13.1016 20 10C20 6.89844 17.4766 4.375 14.375 4.375ZM14.375 14.375C13.5097 14.375 12.6638 14.1184 11.9444 13.6377C11.2249 13.1569 10.6642 12.4737 10.333 11.6742C10.0019 10.8748 9.91525 9.99515 10.0841 9.14648C10.2529 8.29781 10.6696 7.51826 11.2814 6.90641C11.8933 6.29455 12.6728 5.87787 13.5215 5.70906C14.3701 5.54025 15.2498 5.62689 16.0492 5.95803C16.8487 6.28916 17.5319 6.84992 18.0127 7.56938C18.4934 8.28885 18.75 9.13471 18.75 10C18.7488 11.1599 18.2874 12.272 17.4672 13.0922C16.647 13.9124 15.5349 14.3738 14.375 14.375Z" fill="currentColor"/></svg>',
  trash: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4.12465 5.33334H11.8746L11.4113 12.75C11.3901 13.0885 11.2407 13.4062 10.9935 13.6385C10.7463 13.8707 10.4198 14 10.0806 14H5.91931C5.58013 14 5.2537 13.8707 5.00648 13.6385C4.75926 13.4062 4.60985 13.0885 4.58865 12.75L4.12465 5.33334ZM12.6666 3.33334V4.66668H3.33331V3.33334H5.33331V2.66668C5.33331 2.31305 5.47379 1.97392 5.72384 1.72387C5.97389 1.47382 6.31302 1.33334 6.66665 1.33334H9.33331C9.68693 1.33334 10.0261 1.47382 10.2761 1.72387C10.5262 1.97392 10.6666 2.31305 10.6666 2.66668V3.33334H12.6666ZM6.66665 3.33334H9.33331V2.66668H6.66665V3.33334Z" fill="currentColor"/></svg>',
  crop: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M18.4166 24.9167V20.5833H5.41665V7.58334H1.08331V5.41668H5.41665V1.08334H7.58331V18.4167H24.9166V20.5833H20.5833V24.9167H18.4166ZM18.4166 16.25V7.58334H9.74998V5.41668H20.5833V16.25H18.4166Z" fill="currentColor"/></svg>',
  shrink_to_fit: '<svg width="20" height="16.5" viewBox="0 0 17 14" fill="none"><path d="M15.167 4.33334V1.83334H12.667V0.166677H15.167C15.6253 0.166677 16.0178 0.330011 16.3445 0.656677C16.6712 0.983344 16.8342 1.37557 16.8337 1.83334V4.33334H15.167ZM0.166992 4.33334V1.83334C0.166992 1.37501 0.330326 0.982788 0.656992 0.656677C0.983659 0.330566 1.37588 0.167233 1.83366 0.166677H4.33366V1.83334H1.83366V4.33334H0.166992ZM12.667 13.5V11.8333H15.167V9.33334H16.8337V11.8333C16.8337 12.2917 16.6706 12.6842 16.3445 13.0108C16.0184 13.3375 15.6259 13.5006 15.167 13.5H12.667ZM1.83366 13.5C1.37533 13.5 0.983103 13.337 0.656992 13.0108C0.330881 12.6847 0.167548 12.2922 0.166992 11.8333V9.33334H1.83366V11.8333H4.33366V13.5H1.83366ZM3.50033 10.1667V3.50001H13.5003V10.1667H3.50033ZM5.16699 8.50001H11.8337V5.16668H5.16699V8.50001Z" fill="currentColor"/></svg>',
  minus: '<svg width="18" height="28" viewBox="0 0 18 28" fill="none"><path d="M13.6668 14.9697H4.3335V13.6364H13.6668V14.9697Z" fill="currentColor"/></svg>',
  plus: '<svg width="18" height="28" viewBox="0 0 18 28" fill="none"><path d="M14.0003 14.9697H10.0003V18.9697H8.66699V14.9697H4.66699V13.6364H8.66699V9.63637H10.0003V13.6364H14.0003V14.9697Z" fill="currentColor"/></svg>',
  checkbox: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM11.358 5.646C11.2752 5.56358 11.1662 5.51275 11.0498 5.50234C10.9334 5.49192 10.8171 5.52259 10.721 5.589L10.651 5.646L7 9.298L5.354 7.651L5.284 7.593C5.18769 7.52665 5.07116 7.49616 4.95469 7.50684C4.83822 7.51752 4.72918 7.56869 4.64653 7.65145C4.56389 7.73421 4.51288 7.84333 4.50237 7.95981C4.49185 8.0763 4.52251 8.19278 4.589 8.289L4.646 8.359L6.646 10.359L6.716 10.416C6.7995 10.4736 6.89855 10.5045 7 10.5045C7.10145 10.5045 7.2005 10.4736 7.284 10.416L7.354 10.358L11.358 6.354L11.416 6.284C11.4826 6.18769 11.5132 6.07108 11.5026 5.95449C11.492 5.8379 11.4408 5.72873 11.358 5.646Z" fill="currentColor"/></svg>',
  bottom_bar_handle: '<svg width="16" height="12" viewBox="0 0 16 12" fill="none"><path d="M8.5 4.826L9.374 5.824C9.46283 5.91784 9.58455 5.97365 9.71362 5.97972C9.8427 5.98579 9.96912 5.94165 10.0664 5.85656C10.1636 5.77147 10.2241 5.65203 10.2353 5.52329C10.2464 5.39455 10.2072 5.2665 10.126 5.166L8.376 3.166C8.32907 3.11246 8.27125 3.06956 8.20641 3.04017C8.14157 3.01078 8.07119 2.99558 8 2.99558C7.92881 2.99558 7.85844 3.01078 7.79359 3.04017C7.72875 3.06956 7.67093 3.11246 7.624 3.166L5.874 5.166C5.79278 5.2665 5.75362 5.39455 5.76474 5.52329C5.77586 5.65203 5.83639 5.77147 5.93363 5.85656C6.03088 5.94165 6.1573 5.98579 6.28638 5.97972C6.41545 5.97365 6.53717 5.91784 6.626 5.824L7.5 4.826V8.505C7.5 8.63761 7.55268 8.76478 7.64645 8.85855C7.74021 8.95232 7.86739 9.005 8 9.005C8.13261 9.005 8.25979 8.95232 8.35355 8.85855C8.44732 8.76478 8.5 8.63761 8.5 8.505V4.826ZM2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H14C14.5304 12 15.0391 11.7893 15.4142 11.4142C15.7893 11.0391 16 10.5304 16 10V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0H2ZM1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V7H9.5V8.505C9.5 8.90282 9.34196 9.28436 9.06066 9.56566C8.77936 9.84696 8.39782 10.005 8 10.005C7.60218 10.005 7.22064 9.84696 6.93934 9.56566C6.65804 9.28436 6.5 8.90282 6.5 8.505V7H1V2Z" fill="currentColor"/></svg>',
  info_circle: '<svg width="16" height="16" viewBox="0 0 640 640"><path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z" fill="currentColor"/></svg>'
};
